import { useEffect, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/context/auth-context';
import { setCurrency } from '@/lib/currency';
import { Button } from '@/components/ui/Button';
import { settingsApi, settingsKey } from './settings.api';

/** Load before showing amounts, including direct links and fullscreen editors. */
export const SettingsBootstrap = ({ children }: { children: ReactNode }) => {
  const { status } = useAuth();
  const settings = useQuery({
    queryKey: settingsKey,
    queryFn: settingsApi.read,
    enabled: status === 'authenticated',
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
  useEffect(() => {
    if (status === 'anonymous') setCurrency('EUR');
  }, [status]);
  if (status !== 'authenticated') return children;
  if (settings.isPending)
    return (
      <p role="status" className="text-ink-500 p-8 text-sm">
        Chargement de votre espace…
      </p>
    );
  if (settings.isError && !settings.data)
    return (
      <div role="alert" className="space-y-4 p-8">
        <p>Impossible de charger les préférences de l’entreprise.</p>
        <Button
          onClick={() => {
            void settings.refetch();
          }}
        >
          Réessayer
        </Button>
      </div>
    );
  return children;
};
